import styled from 'styled-components';

import { BorderRadius } from '@lichtblick/theme/constants/border';
import { Colors } from '@lichtblick/theme/constants/colors';
import { Spacing } from '@lichtblick/theme/constants/spacing';
import { MediaDesktop } from '@lichtblick/theme/utils/breakpoints';
import { Text } from '@lichtblick/ui-components';

export const Card = styled.div<{ $backgroundColor: Colors }>`
  align-items: flex-start;
  align-self: stretch;
  background: ${({ $backgroundColor }) => $backgroundColor};
  border-radius: ${BorderRadius.S};
  display: flex;
  flex-direction: column;
  height: 100%;

  .picture-mobile,
  .picture-desktop {
    /* stylelint-disable-next-line meowtec/no-px */
    height: 197px;
    ${MediaDesktop} {
      /* stylelint-disable-next-line meowtec/no-px */
      height: 253px;
    }
  }

  overflow: hidden;
  position: relative;
`;

export const OuterContentWrapper = styled.div`
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  padding: ${Spacing.M};
`;
export const InnerContentWrapper = styled.div`
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: ${Spacing.Xs};
  margin-bottom: ${Spacing.Xxs};
`;

export const RowHeadline = styled(Text).attrs({ isBold: true, size: 'S' })`
  margin-top: ${Spacing.Xs};
`;

export const Hint = styled(Text)`
  color: rgba(0, 0, 0, 0.6);
`;
export const ImageWrapper = styled.div`
  margin-bottom: ${Spacing.M};
  position: relative;
`;
export const InterfererRoot = styled.div`
  background-color: ${Colors.Orange};
  box-shadow: 0 0 0 200vmax ${Colors.Orange};
  clip-path: circle(71%);
  line-height: 150%;
  overflow: hidden;
  padding: ${Spacing['3Xs']};
  position: absolute;
  right: 1.5rem;
  text-align: center;
  top: 2.5rem;
  transform: rotate(0.03turn);
  vertical-align: middle;
  width: 5rem;
`;
